import { apiFetch } from "../api";
import { IExecutionPerformanceResponse } from "./types";

/**
 * Performance de execução das oportunidades (volume/clientes movimentados vs. total oferecido),
 * consolidada e por assessor/oportunidade, para o painel do gestor.
 *
 * Exemplo de URL:
 *   http://localhost:8080/management/execution_performance?start=2026-06-01T00:00:00.000Z&end=2026-07-09T00:00:00.000Z
 */
export const fetchExecutionPerformance = async (params: {
    start: string;
    end: string;
    /**
     * Inclui movimento solicitado/processando no executado. Por padrão só movimento liquidado
     * conta — a diferença entre os dois é grande o suficiente para mudar a leitura do painel,
     * então é escolha explícita de quem olha, não default silencioso.
     */
    includePending?: boolean;
}): Promise<IExecutionPerformanceResponse> => {
    const query = new URLSearchParams({
        start: params.start,
        end: params.end,
    });

    if (params.includePending) {
        query.set("include_pending", "true");
    }

    const data = await apiFetch(`/management/execution_performance?${query.toString()}`);
    return data as IExecutionPerformanceResponse;
};
